import angular from 'angular';
import PosMovementsComponent from './movements.component';

const posMovementsModule = angular.module('tinaba.dashboard.pos.movements', [])

.component('posMovements', PosMovementsComponent);

export default posMovementsModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/dashboard/pos/movements/movements.js
 **/